<template>
    <div>
      <div id="nav" class="navbar" role="navigation" aria-label="main navigation">
        <!-- <div class="nav-left">
          <router-link class="nav-logo" to="/"><img class="logo" src="@/assets/logo.svg" alt="Martin Préjean Logo"></router-link>
        </div> -->
        <div class="nav-left">
          <router-link class="nav-logo" to="/">• N X T T Y •</router-link>
        </div>
        <div class="navbar-brand">
          <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" @click="isOpen = !isOpen" v-bind:class="{'is-active': isOpen}">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
          </a>
        </div>
      </div>

      <transition name="burger">
        <div class="navbar-menu" v-bind:class="{'is-active': isOpen}">
          <div class="navbar-end">
            <div class="item item-1">
              <a id="home" class="navbar-item is-tab" href="/" exact>Home</a>
            </div>
            <div class="item item-2">
              <a class="navbar-item is-tab" href="/photo" exact>Photo</a>
            </div>
            <div class="item item-3">
              <a class="navbar-item is-tab" href="/conception-graphique">Conception Graphique</a>
            </div>
            <div class="item item-4">
              <a class="navbar-item is-tab" href="/typographie">Typographie</a>
            </div>
            <div class="item item-5">
              <a class="navbar-item is-tab" href="/laboratoire-graphique">Laboratoire Graphique</a>
            </div>
            <div class="item item-6">
              <a class="navbar-item is-tab" href="/creation-visuelle-et-sonore">Création Visuelle et Sonore</a>
            </div>
            <div class="item item-7">
              <a class="navbar-item is-tab" href="/creative-writing">Creative Writing</a>
            </div>
            <div class="item item-8">
              <a class="navbar-item is-tab" href="/projets-personnels">Projets Personnels</a>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            isOpen: false
        }
    }
}
</script>